import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DadosFormComponent } from './dados-form.component';
import { DadosFormResolver } from './dados-form.resolver';
import { MenuComponent } from 'src/app/menu/menu.component';


const routes: Routes = [
  {
    path: '',
    component: MenuComponent,
    children: [
      {
        path: '',
        component: DadosFormComponent,
      },
      {
        path: ':idDoador',
        component: DadosFormComponent,
        resolve:{
          doador:DadosFormResolver
        }
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DadosFormRoutingModule { }
